<template>
	<div id="sidebar2-container" :class="{ 'sidebar2-expanded' : !collapsemenu, 'sidebar2-collapsed' : collapsemenu }">
		<div class="logo" :style="cssLogo">
			<router-link :to="{ name : 'Resumen' }">
				<img v-if="logo" :src="require('@/assets/css/content-layout/assets/img/'+ logo)" class="expandedlogo">
				<img v-if="isotipo" :src="require('@/assets/css/content-layout/assets/img/' + isotipo)" class="collapsedlogo">
			</router-link>
			<div class="barrita" :style="'background-color:'+colorBarra"></div>
		</div>
		<div class="list-wrapper">
			<ul class="list-group noselect">
				<div v-for="(i, index) in items" v-bind:key="index" class="list-group-module">
					<router-link :to="{ name: i.enlace }" class="list-group-item list-group-item-action btn-administracion" :class="{'menu-active':menuactive === i.menu }" v-if="i.submenu==='0'" :title="i.menu">
						<span :class="'fa ' + i.icon"></span>
						<span class="menu-collapsed" v-if="!collapsemenu">
							{{i.menu}}
						</span>
					</router-link>
					<a class="list-group-item list-group-item-action btn-administracion list-group-item-collapsable" @click="showSubmenu(i.menu)" :title="i.menu" v-else>
						<span :class="'fa ' + i.icon"></span>
						<span class="menu-collapsed" v-if="!collapsemenu">
							{{i.menu}}
						</span>
					</a>
					<div class="box-submenus" :style="'top:-' + submenuOffset + 'px;'" :class="{'collapsed':i.menu===menu && submenu===1}">
						<div class="arrow" :style="'top:' + (submenuOffset + 15) + 'px;'"></div>
						<div class="box-submenu" v-for="(s, index) in items2" v-bind:key="s.menu+'-'+index">
							<router-link :to="{ name: s.enlace}" class="list-group-item list-group-item-action" v-if="s.menu===i.menu && i.menu===menu && submenu===1" :class="{'menu-active':menuactive === s.submenu }" :title="s.submenu">
								<span>
									{{s.submenu}}
								</span>
							</router-link>
						</div>
					</div>
				</div>
			</ul>
		</div>

		<!--<div class="bottom-menu">
			<a href="#" class="" @click.prevent="SidebarCollapse()">
				<i class="material-icons chevron-right">chevron_right</i>
				<i class="material-icons chevron-left">chevron_left</i>
			</a>
		</div>-->
	</div>
</template>

<style scoped>
#sidebar2-container .logo {background-color: var(--bg-navbar-color);border-right:solid 1px var(--border-navbar-color);}
#sidebar2-container .logo:hover {background-color: var(--bg-navbar-color);}
</style>

<script>
// import $ from 'jquery'
import { mapState, mapActions } from 'vuex'

export default {
	name: 'Sidebar2',
	methods: {
		...mapActions(['doSearchmenu', 'doCollapsemenu']),
		SidebarCollapse: function () {
			this.doCollapsemenu(!this.collapsemenu)
		},
		showForm () {
			if (this.searchmenu) { this.doSearchmenu(false) } else { this.doSearchmenu(true) }
		},
		showSubmenu (menu) {
			if (this.menu !== menu) {
				this.submenu = 0
				this.menu = menu
				this.showSubmenu(menu)
				return false
			}

			this.menu = menu
			if (this.submenu === 0) {
				this.submenu = 1
				this.setSubmenuOffset()
				setTimeout(this.setSubmenuOffset, 1)
			} else {
				this.submenu = 0
			}
		},
		esconderSubmenu (event) {
			event.stopPropagation()
			const menuCollapsed = document.querySelectorAll('.box-submenus.collapsed').length > 0
			if (menuCollapsed) {
				if (!document.getElementById('sidebar2-container').contains(event.target)) {
					this.showSubmenu(null)
				}
			}
		},
		setSubmenuOffset () {
			const submenu = document.querySelector('.box-submenus.collapsed')
			this.submenuOffset = 0
			if (submenu) {
				const bounding = submenu.getBoundingClientRect()
				const wHeight = window.innerHeight || document.documentElement.clientHeight
				if (bounding.bottom > wHeight) {
					this.submenuOffset = bounding.bottom - wHeight
				}
			}
		}
	},
	mounted () {
		// OCULTAR MENU POR DEFECTO
		this.SidebarCollapse()
		var add = 0
		this.accessMenu.forEach((value, key) => {
			if (value.menu !== null) {
				this.items.forEach((value1, key) => {
					if (value1.menu === value.menu) { add = 1 }
				})
				if (value.tipo === '1' && add === 0) { this.items.push({ menu: value.menu, enlace: value.enlace, submenu: value.submenu, icon: value.fa_icon, svg: value.svg, subsvg: value.subsvg }) }
				add = 0
			}
		})
		this.accessMenu.forEach((value, key) => {
			if (value.submenu.length > 1) { this.items2.push({ menu: value.menu, submenu: value.submenu, enlace: value.enlace, icon: value.fa_icon_p, svg: value.svg, subsvg: value.subsvg }) }
		})
		document.body.addEventListener('click', this.esconderSubmenu)
	},
	data () {
		return {
			// Note 'isActive' is left out and will not appear in the rendered table
			iscollapse: true,
			submenu: 0,
			items: [],
			items2: [],
			Subitems: [],
			menu: '',
			menuactive: '',
			submenuOffset: 0
		}
	},
	computed: {
		...mapState([
			'accessToken',
			'searchmenu', 'filter', 'collapsemenu', 'accessMenu', 'colorBarra', 'bgNavbarColor', 'borderNavbarColor', 'logo', 'isotipo']),
		cssLogo () {
			return {
				'--bg-navbar-color': this.bgNavbarColor,
				'--border-navbar-color': this.borderNavbarColor
			}
		}
	},
	watch: {
		$route (to, from) {
			if (this.collapsemenu) {
				this.showSubmenu(null)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Sidebar2.vue